export class GtagService {
    constructor(applicationId) {
        this.applicationId = applicationId;
    }
    pushEvent(event) {
        if (typeof gtag === "undefined" || !event) {
            return;
        }
        if (!this.previousEvent || JSON.stringify(this.previousEvent) !== JSON.stringify(event)) {
            this.processEvent(event);
        }
    }
    processEvent(e) {
        if (e) {
            switch (e.action) {
                case "view_item":
                case "add_to_cart": {
                    this.currentCart = e.cart;
                    const cartItems = [];
                    e.cartItems.forEach((i) => {
                        const cartItem = this.currentCart.items.find((ci) => ci.sku === i.sku || ci.productId === i.productId);
                        if (cartItem) {
                            cartItems.push(cartItem);
                        }
                    });
                    gtag("event", e.action, this.getValueByCart(e.cart, cartItems));
                    break;
                }
                case "begin_checkout":
                case "view_cart": {
                    this.currentCart = e.cart;
                    gtag("event", e.action, this.getValueByCart(e.cart, e.cart.items));
                    break;
                }
                case "remove_from_cart": {
                    if (this.currentCart) {
                        let cartItems = [];
                        if (!e.cartItemId) {
                            cartItems = this.currentCart.items;
                        }
                        else {
                            const cartItem = this.currentCart.items.find((ci) => ci.id === e.cartItemId);
                            if (cartItem) {
                                cartItems.push(cartItem);
                            }
                        }
                        gtag("event", e.action, this.getValueByCart(this.currentCart, cartItems));
                    }
                    break;
                }
                case "view_item_list":
                case "select_item": {
                    gtag("event", e.action, this.getValueByProduct(e.products, e.searchTerm));
                    break;
                }
                case "purchase": {
                    gtag("event", "add_payment_info", this.getPaymentInfoByOrder(e.order));
                    gtag("event", e.action, this.getValueByOrder(e.order));
                    break;
                }
            }
        }
    }
    getValueByProduct(products, searchTerm) {
        if (!products) {
            return null;
        }
        const val = {
            item_list_id: searchTerm,
            item_list_name: searchTerm,
            items: [],
        };
        products.forEach((p, index) => {
            val.items.push({
                item_id: p.sku,
                item_name: p.name,
                affiliation: this.applicationId,
                discount: p.basePrice - p.price,
                index: index,
                item_brand: this.applicationId,
                price: p.price,
                quantity: 1,
            });
        });
        return val;
    }
    getValueByCart(cart, items) {
        if (!cart || !items) {
            return null;
        }
        const val = {
            currency: cart.currency.currencyCode,
            value: cart.cartAmount,
            coupon: cart.coupons && cart.coupons.length > 0 ? cart.coupons[0].code : null,
            items: [],
        };
        items.forEach((cartItem, index) => {
            val.items.push({
                item_id: cartItem.sku,
                item_name: cartItem.name,
                affiliation: this.applicationId,
                coupon: cart.coupons && cart.coupons.length > 0 ? cart.coupons[0].code : null,
                discount: cartItem.originalPrice - cartItem.salePrice,
                index: index,
                item_brand: this.applicationId,
                price: cartItem.originalPrice,
                quantity: cartItem.quantity,
            });
        });
        return val;
    }
    getPaymentInfoByOrder(order) {
        if (!order) {
            return null;
        }
        const paymentInfo = {
            currency: order.currency.currencyCode,
            value: order.total,
            payment_type: order.creditCardTypeText,
            items: [],
        };
        paymentInfo.items = this.getItemsByOrder(order);
        return paymentInfo;
    }
    getValueByOrder(order) {
        if (!order) {
            return null;
        }
        const val = {
            transaction_id: order.orderNumber,
            currency: order.currency.currencyCode,
            value: order.total,
            tax: order.taxTotal,
            items: [],
        };
        val.items = this.getItemsByOrder(order);
        return val;
    }
    getItemsByOrder(order) {
        const items = [];
        order.products.forEach((p, index) => {
            var _a;
            items.push({
                item_id: p.sku,
                item_name: p.name,
                affiliation: this.applicationId,
                discount: p.discountTotal,
                index: index,
                item_brand: this.applicationId,
                price: p.priceIncludingTax,
                quantity: p.quantity,
                coupon: ((_a = p.discounts) === null || _a === void 0 ? void 0 : _a.length) > 0 ? p.discounts[0].code : null,
            });
        });
        return items;
    }
}
